export const PRIMARY = '#0091da';
export const PRIMARY_ALT = '#4b4687';
export const WARNING = '#c06f18';
export const DANGER = '#f05948';
export const SUCCESS = '#009c91';
